import ReactGA from 'react-ga';

const TRACKING_ID = 'UA-115960972-2';

export default class Analytics {
  static Initialize() {
    ReactGA.initialize(TRACKING_ID);
  }

  static LogPageView(location) {
    ReactGA.pageview(location.pathname + location.search);
  }
}


// WEBPACK FOOTER //
// src/helpers/analytics.js